import { ModuleWithProviders, NgModule } from '@angular/core';
import { LAYOUT_PAGE_TITLE } from '@spaq/core';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { CsdmViewPageComponent } from './pages';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { ServicesModule } from '@spaq/modules/services';

@NgModule({
	imports: [SharedCommonModule, SharedComponentsModule, UploadsModule, ServicesModule],
	declarations: [CsdmViewPageComponent],
	exports: [CsdmViewPageComponent]
})
export class CsdmModule {
	static forRoot(): ModuleWithProviders<CsdmModule> {
		return {
			ngModule: CsdmModule,
			providers: [
				{
					provide: LAYOUT_PAGE_TITLE,
					useValue: new BehaviorSubject('Transfert de fichier')
				}
			]
		};
	}
}
